
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/photos",
      function () {
        return require("private-next-pages/page/[subdomain]/photos.tsx");
      }
    ]);
  